( function( $ ) {
	var $hero = $( '.hero' );
	var $productTypes = $( '.product-types' );
	var $leadForm = $( '.ignite-lead-form' );
	var $footerForm = $( '.footer-lead-form' );

	if( $hero.next().is( '.product-types' ) ) {
		$productTypes.addClass( 'product-types--lead-form' )
		$leadForm.addClass( 'ignite-lead-form--homepage' )
	}
	$($footerForm.children()[0]).removeClass("ignite-lead-form--homepage");
	
} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/partials/lead-form.js